'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPrefixedValue;
var regex = /-webkit-|-moz-|-ms-/;

function isPrefixedValue(value) {
  return typeof value === 'string' && regex.test(value);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-plugin-prefixer/node_modules/inline-style-prefixer/node_modules/css-in-js-utils/lib/isPrefixedValue.js
// module id = 78
// module chunks = 0